<template>
  <div class="home">

  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
    }
  }
}
</script>

<style>
body{
  background-color: lightblue;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.active{
  font-family: Lato;
  font-size:1.90rem;
  color: white;
}
.main-nav{
  background-color: black;
}
.clean-list{
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// Hello.vue?3d15716a